<template>
    <figure class="hall-cover"
        :class="{
            [disabled ? 'disabled' : 'normal']: true, 
            [`hall-${hallOrderNo}`]: true, 
        }"
    >
        <img
            class="hall-cover-img"
            :src="oCurPics[`cover`]"
            alt=""
        /> 
        <!--
            ↑ 背景图 
            ↓ 内容 
        -->
        <div class="content"> 
            <!-- <h5 class="title">
                <img :src="oCurPics[`title`]" alt="" />
            </h5> -->
            <div class="info-box">
                <span>
                    <CurrentCoin
                        size="12px"
                        class="inline-flex coin-pic"
                    />
                    {{  $t('goldenFlower.access') }}:
                    <em>
                        {{ number2LocaleString(info.minimumEntry, 1) }}
                    </em>
                </span>
                <span>
                    <CurrentCoin
                        size="12px"
                        class="inline-flex coin-pic"
                    />
                    {{  $t('goldenFlower.ante') }}:
                    <em>
                        {{ number2LocaleString(info.minBet, 1) }}
                    </em>
                </span>
            </div>
        </div>
    </figure>
</template>

<script lang="ts" setup>
import { fnGetCoverPics } from '../ts/goldenFlowerCommon'; 

const props = defineProps({
    hallOrderNo: {
        type: Number, 
        required: true, 
    },
    disabled: {
        type: Boolean,
    },
    info: {
        type: Object,
        default: () => ({}),
    },
});

const $i18n = useNuxtApp().$i18n;
const oPics = fnGetCoverPics();

const sLang = computed(()=>{
    return $i18n.locale.value;
});

const oCurPics = computed(()=>{
    const sNumber = `-0${props.hallOrderNo}`;
    const sJoin = `join-${sLang.value}`;
    const oResult = {
        join: oPics[sJoin],
    };
    Object.keys(oPics).forEach(key=>{
        const rightLang = (
            key.includes('title')
            ? key.includes(sLang.value)
            : true
        );
        if (key.includes(sNumber) && rightLang){ 
            const [shortKey] = key.split('-');
            oResult[shortKey] = oPics[key];
        }
    });
    return oResult; 
});


onMounted(()=>{
    // console.log('fnGetCoverPics\n', fnGetCoverPics());
    // console.log('oCurPics\n', deepCopy(oCurPics.value)); 
});


</script>

<style scoped lang="scss" >
.hall-cover{
    min-width: 90px; 
    min-height: 100px; 
    max-width: min(45vw, 200px); 
    position: relative; 
    font-size: 10px;
    transition: all 0.2s; 
    cursor: pointer; 
    &.normal:hover{
        transform: translateY(2px); 
    }
    &.normal:active{
        transform: translateY(4px); 
        filter: brightness(1.15);
    }
    &.disabled{
        opacity: 1 !important; 
        filter: brightness(0.5);
    }
}

.hall-cover-img{
    filter: drop-shadow(2px 6px 10px rgb(0,0,0, 0.7));
    width: 100%;
}

@media screen and (max-width: 380px){
    .hall-cover{
        font-size: 9px; 
    }
}

.content{
    position: absolute; 
    bottom: 0;
    left: 0;
    right: 0; 
    width: 100%;
    user-select: none; 
    text-align: center; 
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    color: white; 
    & > *{
        display: flex;
        justify-content: center; 
        align-items: center; 
        min-height: 5px; 
        text-align: center; 
    }
    .title{
        margin-top: 10px; 
        width: 100%;
        color: white; 
        img{
            margin: 0 auto; 
            max-width: 90%; 
            max-height: 40px; 
        }
    }
    .info-box{
        margin: 0 auto 10px auto;
        display: flex;
        // flex-direction: column;
        // gap: 4px;
        span{
            background: rgba(17, 25, 35, 0.9);
            color: rgba(255, 255, 255, 0.8);
            min-width: 4.1667vw;
            min-height: 18px;
            padding: 3px 8px;
            border-radius: 6px;
            border: solid 1px rgba(255,255,255, 0.4);
            display: flex;
            justify-content: center; 
            align-items: center; 
            text-align: center; 
            font-size: 9px;
            .coin-pic{
                margin: 0 2px 0 0;
            }
            em{
                color: rgba(255, 255, 255, 0.9); 
                font-weight: bold; 
                margin: 0 0 0 3px; 
            }
        }
    }
}

// 移除hall-5样式，因为现在只有4个厅

</style>

